import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexGrow: 1,
    height: theme.spacing(6),
    color: theme.palette.text.secondary,
    background: theme.palette.custom.background.area,
    minWidth: theme.spacing(18),
    width: '100%',

    [`
      &:not(:last-child),
      &:first-child
    `]: {
      borderBottom: `solid 1px ${theme.palette.divider}`,
    },

    '&.sticked': {
      position: 'sticky',
      top: 0,
      zIndex: 1,
    },

    '& .slot-content': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexGrow: 1,
    },

    '&.label': {
      '& .slot-content': {
        background: theme.palette.custom.surface[0],
      },
    },

    '& .slot-button': {
      '&-container, &-icon, &-text, &-arrow, &-vacancies': {
        transition: theme.transitions.create(),
      },
      '&-container': {
        display: 'flex',
        flexGrow: 1,
        alignItems: 'center',
        padding: theme.spacing(0, 2),
        height: '100%',
      },
      '&-icon': {
        marginRight: theme.spacing(1),
        color: theme.palette.primary.main,
      },
      '&-text': {
        flexGrow: 1,
        textAlign: 'left',
        fontWeight: 600,
      },
      '&-vacancies': {
        height: theme.spacing(5 / 2),
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        background: theme.palette.custom.surface[3],
        borderRadius: theme.spacing(1 / 2),
        color: theme.palette.text.hint,
        marginLeft: theme.spacing(1),
      },
    },

    '&:not(.scheduled):not(.fullroom):not(.before-now)': {
      '& .slot-button': {
        '&-container:hover': {
          background: theme.palette.primary.main,

          '& .slot-button': {
            '&-icon, &-text, &-arrow, &-vacancies': {
              color: theme.palette.getContrastText(theme.palette.primary.main),
            },
          },
        },
      },
    },

    '&.fullroom, &.before-now': {
      '& .slot-button': {
        '&-icon': {
          color: theme.palette.text.hint,
        },
        '&-container': {
          cursor: 'not-allowed',
          opacity: 0.7,

          '&:hover': {
            background: theme.palette.custom.surface[2],
          },
        },
      },
    },

    '&.scheduled': {
      '& .slot-button': {
        '&-icon, &-text': {
          color: theme.palette.custom.feedback.positive,
        },
        '&-container:hover': {
          background: theme.palette.custom.feedback.positive,

          '& .slot-button': {
            '&-icon, &-text, &-arrow, &-vacancies': {
              color: theme.palette.getContrastText(
                theme.palette.custom.feedback.positive,
              ),
            },
          },
        },
      },
    },
  },
}));

export default styles;
